export default __webpack_public_path__ + "static/icon-dark-53223be5c2394859a057a6f9efa14890.png";